import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import firebaseApp from "../fireconnect";
import { useNavigate, useLocation } from "react-router-dom";
import "react-quill/dist/quill.bubble.css";
import { ToastContainer, toast } from "react-toastify";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Button, Modal } from "react-bootstrap";

const ProductsTable = () => {
  const [productd1, setpdata] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [deleteProductId, setDeleteProductId] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.message) {
      toast.success(location.state.message);
    }
  }, [location.state]);

  useEffect(() => {
    GetProductData();
  }, []);

  const GetProductData = async () => {
    const db = firebaseApp.firestore();
    try {
      const querySnapshot = await db.collection("Product").get();
      const data = querySnapshot.docs.map((doc) => doc.data());
      setpdata(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleEdit = async (productId) => {
    if (!productId) return;

    try {
      const db = firebaseApp.firestore();
      const snapshot = await db
        .collection("Product")
        .where("id", "==", productId)
        .get();

      if (!snapshot.empty) {
        const productData = snapshot.docs[0].data();
        navigate("/Admin/Addproduct", { state: { productData } });
      } else {
        toast.error("Product not found");
      }
    } catch (error) {
      console.error("Error editing product:", error);
    }
  };

  const handleView = (product) => {
    setSelectedProduct(product);
    setOpenModal(true);
  };

  const handleDeleteClick = (id) => {
    setDeleteProductId(id);
    setConfirmDeleteOpen(true);
  };

  const confirmDelete = async () => {
    setConfirmDeleteOpen(false);
    const db = firebaseApp.firestore();
    try {
      const snapshot = await db
        .collection("Product")
        .where("id", "==", deleteProductId)
        .get();
      if (!snapshot.empty) {
        const docId = snapshot.docs[0].id;
        await db.collection("Product").doc(docId).delete();

        setpdata((prev) => prev.filter((item) => item.id !== deleteProductId));
        toast.success("Product deleted successfully!");
      } else {
        toast.error("Product not found!");
      }
    } catch (error) {
      console.error("Error deleting product:", error);
      toast.error("Failed to delete product.");
    }
  };

  const columns = [
    {
      name: "pname",
      label: "Product Name",
      options: {
        customBodyRender: (value) =>
          value?.length > 50 ? value.substring(0, 50) + "..." : value,
      },
    },
    {
      name: "pdetails",
      label: "Details",
      options: {
        customBodyRender: (value) => (
          <div
            className="ql-editor"
            style={{
              maxHeight: "100px",
              overflowY: "auto",
              fontSize: "0.9rem",
            }}
            dangerouslySetInnerHTML={{ __html: value }}
          />
        ),
      },
    },
    {
      name: "price",
      label: "Price",
      options: {
        customBodyRender: (value, tableMeta) => {
          const discounted = tableMeta.rowData[3];
          return discounted ? (
            <span style={{ textDecoration: "line-through", color: "red" }}>
              ₹{value}
            </span>
          ) : (
            `₹${value}`
          );
        },
      },
    },
    {
      name: "discountedPrice",
      label: "Discounted Price",
    },
    {
      name: "category",
      label: "Category",
    },
    {
      name: "image",
      label: "Image",
      options: {
        customBodyRender: (value) =>
          Array.isArray(value) && value.length > 0 ? (
            <img
              src={value[0]}
              alt="product"
              style={{ width: "80px", height: "auto", objectFit: "cover" }}
              loading="lazy"
            />
          ) : (
            "No Image"
          ),
      },
    },
    {
      name: "id",
      label: "Actions",
      options: {
        customBodyRender: (value, tableMeta) => {
          const product = productd1[tableMeta.rowIndex];
          return (
            <div>
              <button
                className="btn btn-info btn-sm m-1"
                onClick={() => handleView(product)}
              >
                <i className="bi bi-eye"></i>
              </button>
              <button
                className="btn btn-primary btn-sm m-1"
                onClick={() => handleEdit(value)}
              >
                <i className="bi bi-pencil"></i>
              </button>
              <button
                className="btn btn-danger btn-sm m-1"
                onClick={() => handleDeleteClick(value)}
              >
                <i className="bi bi-trash3"></i>
              </button>
            </div>
          );
        },
      },
    },
  ];

  return (
    <>
      <div className="mt-1 text-start">
        <h4 className="mb-2">Products</h4>
        <ToastContainer />
        <MUIDataTable
          className="AdminTable rounded-2"
          data={productd1}
          columns={columns}
          options={{
            tableBodyHeight: "57vh",
            responsive: "standard",
            selectableRows: "none",
          }}
        />

        <Modal
          show={openModal}
          onHide={() => setOpenModal(false)}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Product Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h6>
              <strong>Product Name:</strong> {selectedProduct?.pname}
            </h6>
            <h6>
              <strong>Category:</strong> {selectedProduct?.category}
            </h6>
            <h6>
              <strong>Price:</strong> ₹{selectedProduct?.price}
            </h6>
            {selectedProduct?.discountedPrice && (
              <h6>
                <strong>Discounted:</strong> ₹{selectedProduct.discountedPrice}
              </h6>
            )}
            <h6>
              <strong>Details:</strong>
            </h6>
            <div
              className="ql-editor"
              dangerouslySetInnerHTML={{ __html: selectedProduct?.pdetails }}
            />
            {selectedProduct?.image?.length > 0 && (
              <>
                <h6>
                  <strong>Images:</strong>
                </h6>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                  {selectedProduct.image.map((img, idx) => (
                    <img
                      key={idx}
                      src={img}
                      alt={`img-${idx}`}
                      style={{ width: "100px", borderRadius: "5px" }}
                    />
                  ))}
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setOpenModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Dialog
          open={confirmDeleteOpen}
          onClose={() => setConfirmDeleteOpen(false)}
        >
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <p>Are you sure you want to delete this Product?</p>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setConfirmDeleteOpen(false)}
              variant="secondary"
            >
              Cancel
            </Button>
            <Button onClick={confirmDelete} variant="danger">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default ProductsTable;
